import React, { Fragment } from 'react';
import { LANG_JP, language } from 'Root/constants';
import Data from 'Content/content.json';
import Title from './Title';
import Unavailable from '../ProductTutorial/Unavailable';
import Description from './Description';

import './MakeupTutorial.scss';

const MakeupTutorial = ({ selectedLensType, lensIndex }) => {
  const {
    data: {
      productInfo: {
        [language]: {
          [selectedLensType]: {
            [lensIndex]: {
              name,
              availability,
              big_img,
              box_img,
              box_shot = '',
              small_img,
              promotion,
            },
          },
        },
      },
    },
  } = Data;
  const regional = language === LANG_JP ? true : false;

  return (
    <Fragment>
      <Title lensName={name} regional={regional} />
      {availability === 0 && <Unavailable />}
      {availability > 0 && (
        <Description
          big_img={big_img}
          box_img={box_img}
          box_shot={box_shot}
          selectedLensType={selectedLensType}
          small_img={small_img}
          promotion={promotion}
        />
      )}
    </Fragment>
  );
};

export default MakeupTutorial;
